module.exports = __webpack_public_path__ + "static/media/achieve.af7a43fb.svg";